<script>
import { store } from '../../functions/mixins';
import * as sdk from '../../functions/sdk';

export default {
    mixins: [store],
    created() {
        this.$router.push({name: 'send'});
    },
};
</script>

<template>
    <div></div>
</template>
